import { render } from "./instructions-row.vue?vue&type=template&id=66d6070c"
import script from "./instructions-row.vue?vue&type=script&lang=js"
export * from "./instructions-row.vue?vue&type=script&lang=js"

import exportComponent from "/Users/ars62917/Dropbox/voteomatic/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__